import { Checkbox, PasswordInput } from '@mantine/core';
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createB2BAPI } from '../../../api/Interceptor';
import notify from '../../../utils/Notification';
import '../body/AppBody.css';
import { useMediaQuery } from '@mantine/hooks';

const AccountDelete = () => {
    const [formValues, setFormValues] = useState({
        name: '',
        mobileNo: '',
        email: '',
        reason: '',
    });
    const navigate = useNavigate();
    const B2B_API = useMemo(() => createB2BAPI(navigate), [navigate]);
        const [profile, setProfile] = useState({})
            const [loading, setLoading] = useState(false)
        console.log(profile, "profileprofileprofile")
    const handleInputChange = (e) => {
        setFormValues((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };
    const [checked, setChecked] = useState(true);
 const isMobile = useMediaQuery("(max-width: 767px)");
        useEffect(() => {
            featchProfile();
        }, [])
    useEffect(() => {
    if (profile) {
        setFormValues((prev) => ({
            ...prev,
            name: profile.name || prev.name,
            mobileNo: profile.mobileNo || prev.mobileNo,
            email: profile.email || prev.email,
        }));
    }
}, [profile]);

   const featchProfile = async () => {
        try {
            setLoading(true);
            const res = await B2B_API.get("customer/profile").json();
            console.log(res, "resresres")
            setProfile(res.response);
        } catch (error) {
            console.error("Error fetching recommended items:", error);
        } finally {
            setLoading(false);
        }
    }

    const submitHandler = async (e) => {
        e.preventDefault();
        if (!checked)
            return
        try {
            const res = await B2B_API.post(`delete-account`, { json: formValues }).json();
            notify({
                error: false,
                success: true,
                title: res?.message || 'Deleted Successful'
            })
            navigate('/account-delete')
        } catch (error) {
            notify({
                error: true,
                success: false,
                title: error?.message || 'Something went wrong'
            })
        }
    };

    return (
        <div className="view-sign-up router-view-container"  >
            <h1 className="page-title">Delete Account</h1>
            <div style={{ display: 'flex', width: '100%' , justifyContent: 'center',marginBottom: '40px'}}>
                <form className="sign-up-form-basic sign-up-form" style={{marginTop: '0px', width: '50%'}} onSubmit={submitHandler} data-gtm-form-interact-id="1">

                    <div className="form-control required payload-name">
                        <label className="flex-row items-center">
                            <span className="flex-wrap">Name</span><span style={{color:"red"}}>*</span>
                        </label>
                        <div className="input-and-error">
                            <input
                                name="name"
                                className="required-but-empty"
                                value={formValues.name}
                                onChange={handleInputChange}
                                  disabled={!!profile?.name}
                                type="text"
                                required
                            />
                        </div>
                    </div>

                    <div className="form-control required payload-mobile-number">
                        <label className="flex-row items-center">
                            <span className="flex-wrap">Mobile Number</span><span style={{color:"red"}}>*</span>
                        </label>
                        <div className="input-and-error">
                            <input
                                className="required-but-empty"
                                value={formValues.mobileNo}
                                onChange={handleInputChange}
                                  disabled={!!profile?.mobileNo}
                                pattern="[0-9]{10}"
                                maxLength="10"
                                minLength="10"
                                name="mobileNo"
                                onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')} // Removes non-digit characters
                                required
                            />

                        </div>
                    </div>

                    <div className="form-control required payload-email">
                        <label className="flex-row items-center">
                            <span className="flex-wrap">Email</span><span style={{color:"red"}}>*</span>
                        </label>
                        <div className="input-and-error">
                            <input
                                name="email"
                                inputMode="email"
                                value={formValues.email}
                                disabled={!!profile?.email}
                                onChange={handleInputChange}
                                type="email"
                                required
                            />
                        </div>
                    </div>
                       <div className="form-control required payload-email">
                        <label className="flex-row items-center">
                            <span className="flex-wrap">Reason</span><span style={{color:"red"}}>*</span>
                        </label>
                        <div className="input-and-error">
                            <input
                                name="reason"
                                inputMode="text"
                                value={formValues.reason}
                                onChange={handleInputChange}
                                type="text"
                                required
                            />
                        </div>
                    </div>
                    <div style={{display: 'flex', justifyContent: 'center'}}>
                        <button
                            type="submit"
                            className="btn btn-primary btn-submit btn-block"
                            disabled={!checked}
                            style={{ display:"flex", justifyContent: 'center', width: isMobile ? '80%' : '30%', cursor: checked ? 'pointer' : 'not-allowed', opacity: checked ? 1 : 0.8 ,padding: '5px', fontSize: isMobile ? '14px' : '18px'}}
                    >
                        <div>Delete Account</div>
                    </button>
                    </div>
                
                    </form>
            </div>
        </div>
    );
};

export default AccountDelete;
